import React from "react"
import { MemberDropdown } from "@pga/pga-component-library"

const MemberDrop = ({
  me,
  loading,
  options,
  meEmailMigrationData,
  onToggleDoNotShowAgain,
}) => (
  <MemberDropdown
    me={me}
    loading={loading}
    options={options}
    meEmailMigrationData={meEmailMigrationData}
    onToggleDoNotShowAgain={onToggleDoNotShowAgain}
  />
)

export default MemberDrop
